import React, { useEffect, useState } from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useSelector } from 'react-redux';
import headerService from '../../../services/Sections/Promotion/headerService';
import { Home } from '@mui/icons-material';
import { motion } from "motion/react";

const Header = () => {
  const { selectedLanguage } = useSelector(state => state.language);
  const [sectionHeader, setSectionHeader] = useState({
    title: '',
    description: '',
  });

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const data = await headerService.fetchSectionHeader(
          { language: selectedLanguage },
          'Promotion'
        );
        setSectionHeader(data);
      } catch (error) {
        console.error('Error fetching section header:', error);
      }
    };

    fetchHeaderData();
  }, [selectedLanguage]);

  // Native background component
  const NativeBackground = () => {
    // Calculate dynamic grid size to fill the container
    const cellWidth = 40; // Smaller cell width
    const cellHeight = 24; // Smaller cell height
    const cols = Math.ceil(window.innerWidth / cellWidth) + 2; // Extra cells for safety
    const rows = Math.ceil(400 / cellHeight) + 2; // Assume max header height of 400px
    
    let colors = [
      "#3b82f6", // Vibrant blue
      "#ec4899", // Hot pink
      "#10b981", // Emerald green
      "#f59e0b", // Amber
      "#ef4444", // Red
      "#8b5cf6", // Purple
      "#06b6d4", // Cyan
      "#84cc16", // Lime
      "#f97316", // Orange
      "#6366f1", // Indigo
    ];
    
    const getRandomColor = () => {
      return colors[Math.floor(Math.random() * colors.length)];
    };

    return (
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          opacity: 0.3,
          zIndex: 0,
        }}
      >
        {Array.from({ length: rows }).map((_, i) => (
          <Box
            key={`row-${i}`}
            sx={{
              display: "flex",
              height: `${cellHeight}px`,
              borderLeft: "1px solid rgba(148, 163, 184, 0.3)",
            }}
          >
            {Array.from({ length: cols }).map((_, j) => (
              <motion.div
                key={`col-${i}-${j}`}
                style={{
                  position: "relative",
                  height: `${cellHeight}px`,
                  width: `${cellWidth}px`,
                  borderTop: "1px solid rgba(148, 163, 184, 0.3)",
                  borderRight: "1px solid rgba(148, 163, 184, 0.3)",
                  cursor: "pointer",
                  backgroundColor: "#808080", // Light gray background
                }}
                whileHover={{
                  backgroundColor: getRandomColor(),
                  transition: { duration: 0 },
                }}
                animate={{
                  transition: { duration: 2 },
                }}
              >
                {j % 4 === 0 && i % 4 === 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-5px",
                      left: "-8px",
                      width: "16px",
                      height: "10px",
                      color: "rgba(148, 163, 184, 0.5)",
                      pointerEvents: "none",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1"
                      stroke="currentColor"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                  </Box>
                )}
              </motion.div>
            ))}
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        padding: { xs: '20px', sm: '30px', md: '40px' },
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: 'black',
        overflow: 'hidden', // Prevent background overflow
      }}
    >
      {/* Native Background Component */}
      <NativeBackground />

      {/* Breadcrumb Navigation */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          mb: { xs: 2, sm: 3 }, // Add margin bottom for spacing
          display: 'flex',
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ color: 'black', fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
        >
          <Link underline="hover" color="inherit" href="/">
            <Home sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />
          </Link>
          <Typography color="inherit">Compassionate</Typography>
        </Breadcrumbs>
      </Box>

      {/* Header Content */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          maxWidth: { xs: '90%', sm: '80%', md: '70%' },
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: { xs: '1.5rem', sm: '2.5rem', md: '3rem' },
            fontWeight: 700,
            lineHeight: 1.2,
            color: 'black',
            mb: 1,
          }}
        >
          {'Compassionate Appointment'}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'black',
            fontSize: { xs: '0.75rem', sm: '1rem', md: '1.25rem' },
            lineHeight: 1.4,
            maxWidth: '1000px',
          }}
        >
          {sectionHeader.description ||
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;